import { lazy } from 'react'

import { NavigationRoutesFn } from 'modules/core/lib/react-router'

import { getSettingPageMeta } from 'modules/settings/lib/getSettingPageMeta'

const RootPage = lazy(() => import('modules/time_categories_settings/pages/RootPage'))

const timeCategoriesSettingsRoutes: NavigationRoutesFn = (navigation) => {
  return [
    {
      path: navigation.settings.time_categories_settings.path,
      element: <RootPage />,
      handle: {
        meta: () => getSettingPageMeta(navigation, 'time_categories'),
      },
    },
  ]
}

export default timeCategoriesSettingsRoutes
